"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupNode = exports.BinaryOperatorNode = exports.UnaryMinusNode = exports.FunctionCallNode = exports.VariableLookupNode = exports.BooleanLiteralNode = exports.ArrayLiteralNode = exports.StringLiteralNode = exports.NumberLiteralNode = exports.ASTNode = void 0;
/**
 * A node in the abstract syntax tree of a formula.
 */
var ASTNode = /** @class */ (function () {
    function ASTNode() {
        /**
         * The index in the original formula string that this node begins at (i.e. inclusive).
         * This is equal to {@link UNKNOWN_SOURCE_INDEX} if the start index is not known.
         */
        this.sourceStart = ASTNode.UNKNOWN_SOURCE_INDEX;
        /**
         * The index immediately after the index in the original formula string that this node ends at (i.e., this property is exclusive).
         * This is equal to {@link UNKNOWN_SOURCE_INDEX} if the start index is not known.
         */
        this.sourceEnd = ASTNode.UNKNOWN_SOURCE_INDEX;
    }
    Object.defineProperty(ASTNode.prototype, "sourceLength", {
        /**
         * Helper property that calculates the source code length of this node.
         * Returns {@link UNKNOWN_SOURCE_INDEX} if either start or end indices are unknown.
         */
        get: function () {
            if (this.sourceStart === ASTNode.UNKNOWN_SOURCE_INDEX || this.sourceEnd === ASTNode.UNKNOWN_SOURCE_INDEX)
                return ASTNode.UNKNOWN_SOURCE_INDEX;
            return this.sourceEnd - this.sourceStart;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * The constant used to indicate the source code start/index/length of a node is not known.
     */
    ASTNode.UNKNOWN_SOURCE_INDEX = -1;
    return ASTNode;
}());
exports.ASTNode = ASTNode;
var NumberLiteralNode = /** @class */ (function (_super) {
    __extends(NumberLiteralNode, _super);
    function NumberLiteralNode(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    NumberLiteralNode.prototype.visit = function (visitor) {
        return visitor.visitNumberLiteral(this);
    };
    return NumberLiteralNode;
}(ASTNode));
exports.NumberLiteralNode = NumberLiteralNode;
var StringLiteralNode = /** @class */ (function (_super) {
    __extends(StringLiteralNode, _super);
    function StringLiteralNode(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    StringLiteralNode.prototype.visit = function (visitor) {
        return visitor.visitStringLiteral(this);
    };
    return StringLiteralNode;
}(ASTNode));
exports.StringLiteralNode = StringLiteralNode;
var ArrayLiteralNode = /** @class */ (function (_super) {
    __extends(ArrayLiteralNode, _super);
    function ArrayLiteralNode(elements) {
        var _this = _super.call(this) || this;
        _this.elements = elements;
        return _this;
    }
    ArrayLiteralNode.prototype.visit = function (visitor) {
        return visitor.visitArrayLiteral(this);
    };
    return ArrayLiteralNode;
}(ASTNode));
exports.ArrayLiteralNode = ArrayLiteralNode;
var BooleanLiteralNode = /** @class */ (function (_super) {
    __extends(BooleanLiteralNode, _super);
    function BooleanLiteralNode(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    BooleanLiteralNode.prototype.visit = function (visitor) {
        return visitor.visitBooleanLiteral(this);
    };
    return BooleanLiteralNode;
}(ASTNode));
exports.BooleanLiteralNode = BooleanLiteralNode;
var VariableLookupNode = /** @class */ (function (_super) {
    __extends(VariableLookupNode, _super);
    function VariableLookupNode(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        return _this;
    }
    VariableLookupNode.prototype.visit = function (visitor) {
        return visitor.visitVariableLookup(this);
    };
    return VariableLookupNode;
}(ASTNode));
exports.VariableLookupNode = VariableLookupNode;
var FunctionCallNode = /** @class */ (function (_super) {
    __extends(FunctionCallNode, _super);
    function FunctionCallNode(name, parameters) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.parameters = parameters;
        return _this;
    }
    FunctionCallNode.prototype.visit = function (visitor) {
        return visitor.visitFunctionCall(this);
    };
    return FunctionCallNode;
}(ASTNode));
exports.FunctionCallNode = FunctionCallNode;
var UnaryMinusNode = /** @class */ (function (_super) {
    __extends(UnaryMinusNode, _super);
    function UnaryMinusNode(operand) {
        var _this = _super.call(this) || this;
        _this.operand = operand;
        return _this;
    }
    UnaryMinusNode.prototype.visit = function (visitor) {
        return visitor.visitUnaryMinus(this);
    };
    return UnaryMinusNode;
}(ASTNode));
exports.UnaryMinusNode = UnaryMinusNode;
var BinaryOperatorNode = /** @class */ (function (_super) {
    __extends(BinaryOperatorNode, _super);
    function BinaryOperatorNode(left, operator, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.operator = operator;
        _this.right = right;
        return _this;
    }
    BinaryOperatorNode.prototype.visit = function (visitor) {
        return visitor.visitBinaryOperator(this);
    };
    return BinaryOperatorNode;
}(ASTNode));
exports.BinaryOperatorNode = BinaryOperatorNode;
var GroupNode = /** @class */ (function (_super) {
    __extends(GroupNode, _super);
    function GroupNode(content) {
        var _this = _super.call(this) || this;
        _this.content = content;
        return _this;
    }
    GroupNode.prototype.visit = function (visitor) {
        return visitor.visitGroupNode(this);
    };
    return GroupNode;
}(ASTNode));
exports.GroupNode = GroupNode;
//# sourceMappingURL=node.js.map